/**
 * Routes of the budgeting module, spread into the host router. They carry
 * `meta.budgeting` (module permissions, checked by `budgetingGuard`) and no
 * `meta.permissions`, so the host guard lets them through; no `meta.twoFa`:
 * the module does not use 2FA.
 * is the host's and still applies.
 */
import { HUB_ACCESS, HUB_ITEMS, QUOTE_ACCESS } from "./config";
import { panelLocation } from "./panels";
import { budgetingGuard } from "./permissions";

const routes = [
  {
    // The «Orçamentos» hub: a summary, then the module's pages as tabs (`?dom=`; their own tabs in `?sub=`)
    path: "/quotes",
    name: "quotes",
    meta: { tabLabel: "Orçamentos", budgeting: { permissionsAny: HUB_ACCESS } },
    component: () => import("./views/QuotesHub.vue"),
  },
  // The pages that became tabs: their old routes open the hub on them, with their parameters
  ...HUB_ITEMS.filter((item) => item.path).map((item) => ({
    path: item.path,
    redirect: (to) => {
      const query = { ...to.query, dom: item.value };
      // the page's own tabs were `?dom=` before the hub took it
      if (item.nested && to.query.dom) {
        query.sub = to.query.dom;
      }
      return { path: "/quotes", query };
    },
  })),
  // The pages that became side panels of the hub (`?panel=`): their old routes open it over their tab
  {
    path: "/quotes/new",
    redirect: (to) => ({ path: "/quotes", query: { ...to.query, panel: "new" } }),
  },
  {
    path: "/quotes/settings/tables/:tableId(\\d+)",
    redirect: (to) => panelLocation({ path: to.path, query: to.query }, "table", to.params.tableId),
  },
  {
    path: "/quotes/settings/services/:serviceId(\\d+)/:kind(blocks|conditions)",
    redirect: (to) => panelLocation({ path: to.path, query: to.query }, to.params.kind, to.params.serviceId, to.query),
  },
  {
    // The system scheme of a version, drawn from its lines (moves, links, «in the proposal»)
    path: "/quotes/:id(\\d+)/v/:version(\\d+)/scheme",
    name: "quote-scheme",
    meta: { tabLabel: "Esquema", budgeting: { permissionsAny: QUOTE_ACCESS } },
    component: () => import("./views/QuoteScheme.vue"),
  },
  {
    // Without a version number the editor replaces the route with the latest one
    path: "/quotes/:id(\\d+)/v/:version(\\d+)?",
    name: "quote-editor",
    meta: { tabLabel: "Orçamento", budgeting: { permissionsAny: QUOTE_ACCESS } },
    component: () => import("./views/QuoteEditor.vue"),
  },
];

routes.forEach((route) => {
  if (route.redirect) {
    return;
  }
  route.beforeEnter = budgetingGuard;
});

export default routes;
